import actions from './actions';

const MyVoucherTabModule = {
  namespaced: true,
  actions,
};

export default MyVoucherTabModule;
